import { FragmentDefiner, useReadFragment } from "../../../GlobalHooks/useReadFragment";
import { isValidCharacters, showFacilities } from "../../../Utils/Functions";
import { useEffect, useState } from "react";

import { useFilters } from "../Filters.hook";

export const FRAGMENT_FACILITIES_OPTIONS = new FragmentDefiner(
	"Filter",
	`
      id
      name
      options
	`
);
export const FRAGMENT_FACILITIES = new FragmentDefiner(
	"Filters",
	`
      facilities {
        ${FRAGMENT_FACILITIES_OPTIONS.query()}
      }
	`
);
export interface FacilitiesProps {
	filterChanged: ({}: any) => void;
	labeled?: boolean;
	collapsable?: boolean;
	inputType?: "select" | "checkbox-select";
}

export const useFacilities = () => {
	// hook setup
	const { filters, changeFilters } = useFilters();
	const [facilities, setFacilities] = useState([]);
	const [firstTime, setFirstTime] = useState(true);
	const selected = filters?.facilitiesGroup || [];
	const [facilitieSearch, setFacilitieSearch] = useState<string>("");

	const { data, loading } = useReadFragment(FRAGMENT_FACILITIES_OPTIONS, "facilities");

	useEffect(() => {
		if (!firstTime) {
			updateFilters();
			setFacilitieSearch("");
		} else {
			setFirstTime(false);
		}
	}, [facilities]);

	useEffect(() => {
		if (!firstTime && !filters.facilitiesGroup) {
			setFacilities([]);
		}
	}, [filters.facilitiesGroup]);

	const updateFilters = () => {
		let filtered = facilities?.map(v => {
			return { value: v["id"], text: "con " + v["nombre"] };
		});		
		changeFilters({ facilitiesGroup: filtered });
	};

	const onSearch = (val: string) => {
		if (isValidCharacters(val) || val == "") setFacilitieSearch(val);
	};

	const show = showFacilities(filters?.property_type_id, filters?.operation_type_id);

	return {
		facilities: {
			value: facilities,
			set: setFacilities,
			options: data?.options,
			loading,
			selected: selected,
		},
		valFacilitie: facilitieSearch,
		onSearch,
		show,
	};
};
